import {CompanyModel} from 'shared/models/company';
import {useRootSelector} from 'store';
import {selectActiveCompany} from 'store/profile';

export function useCompany(): CompanyModel {
  return useRootSelector(selectActiveCompany);
}
